import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { DataFieldTypeEnum } from "abweb/dto/generated/ds/DataFieldTypeEnum";
import { RecordFieldTypeEnum } from "abweb/dto/generated/ds/RecordFieldTypeEnum";
import { DataSourceFieldBase } from "abweb/dto/generated/ds/DataSourceFieldBase";
import { DataSourceRecord } from "abweb/dto/ds/DataSourceRecord";
import { DataSourceValueVector } from "abweb/dto/ds/DataSourceValueVector";
import { ClassUtils } from "abweb/utils/ClassUtils";
export class DataSourceField extends DataSourceFieldBase {
  static createWithDefaults(fieldType, name) {
    return DataSourceField.createDataSourceField(
    // So why can't this just be called 'create' ?
    [], null, false, fieldType, true, false, null, name,
    // So why isn't this called 'id' - as is with DataSource{,Record} ?
    true, null, null, false, true, RecordFieldTypeEnum.Base, null);
  }
  static createDataSourceField(attributes, defaultValue, editable, fieldType, filterable, hasDependentFields, itemType, name, populated, recordFormat, refObject, required, sortable, type, validation, editableIfNullOnly = false) {
    const retVal = new DataSourceField();
    retVal.initDataSourceField(attributes, defaultValue, name,
    // display name is name by default
    editable, editableIfNullOnly, fieldType, filterable, hasDependentFields, itemType, name, populated, recordFormat, refObject, required, sortable, type, validation);
    return retVal;
  }
  initFromJson(json, deserializeContext) {
    super.initFromJson(json, deserializeContext);
    if (this.recordFormat != null && this.recordFormat.fields != null) {
      // This field has a subrecord so set their parentField
      for (const p in this.recordFormat.fields) {
        if (this.recordFormat.fields.hasOwnProperty(p)) {
          const subField = this.recordFormat.fields[p];
          if (subField) {
            subField._parentField = this;
          }
        }
      }
    } else if (this.itemType != null) {
      // This is a Vector field
      this.itemType._parentField = this;
    }

    // Fix up default values not serialized
    // TODO: This should go away once we have server annotations that can define default values to use
    if (this.filterable == null) {
      this.filterable = true;
    }
    if (this.sortable == null) {
      this.sortable = true;
    }
  }
  findField(fieldPath) {
    switch (this.type) {
      case RecordFieldTypeEnum.Base:
        if (this.name === fieldPath)
          // we had better be at the end of the path!
          {
            return this;
          }
        break;
      case RecordFieldTypeEnum.Vector:
        if (this.itemType == null) {
          return null;
        }
        return this.itemType.findField(fieldPath);
      case RecordFieldTypeEnum.Record:
        if (this.recordFormat == null) {
          // Could happen for DYNAMMIC fields
          return null;
        }
        return this.recordFormat.findField(fieldPath);
      default:
        break;
    }
    return null;
  }

  /**
   * Set up the _field value on each item of the vector value.
   * 'this' is the metadata for the items.
   * @param vector the DataSourceValueVector holding items to set the _field on.
   * @param rec the DataSourceRecord that owns the vector.
   * @param dataSource the DataSource that contains the record.
   */
  setUpVectorFields(vector, rec, dataSource) {
    const items = vector.items;
    for (const item of items) {
      item._field = this;
      item._containerRecord = vector;
      item._dataSource = dataSource;
      if (ClassUtils.isInstanceOf(item, DataSourceRecord) && this.recordFormat) {
        this.recordFormat.setUpFields([item], dataSource, null, rec);
      } else if (ClassUtils.isInstanceOf(item, DataSourceValueVector) && this.itemType) {
        this.itemType.setUpVectorFields(item, rec, dataSource);
      } else {
        // Assume we have a simple non-container DataSourceValue
        item.initializeState();
      }
    }
  }
  constructor() {
    super();
    _defineProperty(this, "_parentField", null);
  }
  get parentField() {
    return this._parentField;
  }

  /**
   * Gets fully qualified name of this field.
   */
  get qualifiedName() {
    if (this._qualifiedName == null) {
      // Compute it now
      let qName = this.name != null ? this.name : "";
      for (let p = this.parentField; p != null; p = p.parentField) {
        qName = p.name + "." + qName;
      }
      this._qualifiedName = qName;
    }
    return this._qualifiedName;
  }
  clone() {
    const attributes = this.attributes ? this.attributes.slice() : null;
    return DataSourceField.createDataSourceField(attributes, this.defaultValue, this.editable, this.fieldType, this.filterable, this.hasDependentFields, this.itemType, this.name, this.populated, this.recordFormat, this.refObject, this.required, this.sortable, this.type, this.validation);
  }
  get required() {
    // just in case a null is the runtime value, treat null as false
    return super.required === true;
  }
  set required(value) {
    /* All I want to do is override the getter, but if I don't override the setter
    I get TypeError: Cannot set property required of #<DataSourceField> which has only a getter
    So I have to override this but I can't call super.required = value because that
    is another TypeScript issue.
     */
    super.required = value;
  }
  get isReferenceField() {
    return this.fieldType === DataFieldTypeEnum.REFERENCE;
  }
  get isVectorField() {
    return this.type === RecordFieldTypeEnum.Vector;
  }
  get isRecordField() {
    return this.type === RecordFieldTypeEnum.Record;
  }

  /**
   * Gets whether this field is a Vector field or is contained inside a Vector field.
   * @returns {boolean}
   */
  isInVector() {
    let f = this;
    while (f != null) {
      if (f.isVectorField) {
        return true;
      }
      f = f.parentField;
    }
    return false;
  }

  /**
   * Call this when isInVector() returns true to get the ancestor Vector field that contains me.
   * @returns {DataSourceField | null}
   */
  getContainingVectorField() {
    let field = this;
    while (field) {
      if (field.isVectorField) {
        return field;
      }
      field = field.parentField;
    }
    return null;
  }
}
//# sourceMappingURL=DataSourceField.js.map
